import * as React from "react";
const SvgSoundOn = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M18.5678 7.75961C18.278 7.46978 17.8431 7.46978 17.5533 7.75961C17.2635 8.04945 17.2635 8.48435 17.5533 8.77414C18.8579 10.0787 18.8579 12.1081 17.5533 13.4124C17.2635 13.7023 17.2635 14.1372 17.5533 14.427C17.6983 14.572 17.8431 14.7168 18.1332 14.7168C18.2783 14.7168 18.5681 14.7168 18.7132 14.427C20.4522 12.8327 20.4522 9.78889 18.5679 7.75933L18.5678 7.75961Z",
	fill: "#969FA8"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M13.6387 0.802087C13.6387 0.802087 6.10148 7.32508 5.37658 7.32508H2.04288C1.31798 7.32508 0.738281 7.90477 0.738281 8.62967V13.1229C0.738281 13.8477 1.3182 14.5723 2.18769 14.5723H4.94169C5.81141 14.5723 13.6388 21.3852 13.6388 21.3852C14.0737 21.82 15.2333 21.9651 15.2333 20.5155V1.38212C15.2333 0.0775258 14.3637 0.0775259 13.6388 0.802201L13.6387 0.802087Z",
	fill: "#969FA8"
}));
export default SvgSoundOn;
